import { render, staticRenderFns } from "./JsonSchemas.vue?vue&type=template&id=bc5b3960&scoped=true&"
import script from "./JsonSchemas.vue?vue&type=script&lang=js&"
export * from "./JsonSchemas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b3960",
  null
  
)

export default component.exports